import { FormDatePicker, FormInput, FormSelect, Loader } from "@/components";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useFinancialReporting from "./useMbaplFinancialReporting";
import {
  AS_ON,
  CURRENT_RATIO,
  DE,
  EBITDA,
  EBITDA_MARGIN,
  GROSS_BLOCK,
  PAT,
  PAT_MARGIN,
  ROCE,
  RONW,
  TOTAL_DEBT,
  TURN_OVER,
  YEAR,
} from "./consts";
import { cn, yearOptions } from "@/lib/utils";

const MbaplFinancialReporting = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isLoadingFinance,
    isAddPending,
  } = useFinancialReporting();
  const { errors } = form.formState;


  return (
    <div className="p-4 md:p-6">
      {isLoadingFinance ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            {/* Tabs */}
            
            <div className="bg-white rounded-sm px-[30px] py-[25px]">
              
                  <div
                    
                    className={cn(
                      "pb-6" )}
                  >
                    <span className="text-[16px] font-semibold text-primary">
                     Madhya Bharat Agro Products Limited (MBAPL)
                    </span>
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-[20px] mt-3">
                      <FormSelect
                        name={`${YEAR}`}
                        control={form.control}
                        label="Year"
                        placeholder="Please enter"
                        error={(errors as any)?.[YEAR]?.message}
                        isRequired={requiredFields.includes(`${YEAR}`)}
                        options={yearOptions(5)}
                      />
                      <FormDatePicker
                        name={`${AS_ON}`}
                        label="As On"
                        placeholder="Please Select"
                        error={
                          (errors as any)?.[AS_ON]?.message as string
                        }
                        isRequired
                      />
                      <FormInput
                        name={`${TURN_OVER}`}
                        control={form.control}
                        label="Turn Over(in Cr)"
                        placeholder="Please enter"
                        error={(errors as any)?.[TURN_OVER]?.message}
                        isRequired={requiredFields.includes(
                          `${TURN_OVER}`
                        )}
                        variant="float"
                        startIcon="₹"
                      />
                      <FormInput
                        name={`${EBITDA}`}
                        control={form.control}
                        label="EBITDA (PBDIT)(in Cr)"
                        placeholder="Please enter"
                        error={(errors as any)?.[EBITDA]?.message}
                        isRequired={requiredFields.includes(`${EBITDA}`)}
                        variant="float"
                        startIcon="₹"
                      />
                      <FormInput
                        name={`${EBITDA_MARGIN}`}
                        control={form.control}
                        label="EBITDA Margin(in %)"
                        placeholder="Please enter"
                        error={(errors as any)?.[EBITDA_MARGIN]?.message}
                        isRequired={requiredFields.includes(
                          `${EBITDA_MARGIN}`
                        )}
                        variant="float"
                      />
                      <FormInput
                        name={`${PAT}`}
                        control={form.control}
                        label="PAT(in Cr)"
                        placeholder="Please enter"
                        error={(errors as any)?.[PAT]?.message}
                        isRequired={requiredFields.includes(`${PAT}`)}
                        variant="float"
                        startIcon="₹"
                      />
                      <FormInput
                        name={`${PAT_MARGIN}`}
                        control={form.control}
                        label="PAT Margin(in %)"
                        placeholder="Please enter"
                        error={(errors as any)?.[PAT_MARGIN]?.message}
                        isRequired={requiredFields.includes(
                          `${PAT_MARGIN}`
                        )}
                        variant="float"
                      />
                      <FormInput
                        name={`${GROSS_BLOCK}`}
                        control={form.control}
                        label="Gross Block(in Cr)"
                        placeholder="Please enter"
                        error={(errors as any)?.[GROSS_BLOCK]?.message}
                        isRequired={requiredFields.includes(
                          `${GROSS_BLOCK}`
                        )}
                        variant="float"
                        startIcon="₹"
                      />
                      <FormInput
                        name={`${DE}`}
                        control={form.control}
                        label="D/E"
                        placeholder="Please enter"
                        error={(errors as any)?.[DE]?.message}
                        isRequired={requiredFields.includes(`${DE}`)}
                        variant="float"
                      />
                      <FormInput
                        name={`${ROCE}`}
                        control={form.control}
                        label="ROCE(in %)"
                        placeholder="Please enter"
                        error={(errors as any)?.[ROCE]?.message}
                        isRequired={requiredFields.includes(`${ROCE}`)}
                        variant="float"
                      />
                      <FormInput
                        name={`${CURRENT_RATIO}`}
                        control={form.control}
                        label="Current Ratio"
                        placeholder="Please enter"
                        error={(errors as any)?.[CURRENT_RATIO]?.message}
                        isRequired={requiredFields.includes(
                          `${CURRENT_RATIO}`
                        )}
                        variant="float"
                      />
                      <FormInput
                        name={`${TOTAL_DEBT}`}
                        control={form.control}
                        label="Total Debt(in Cr)"
                        placeholder="Please enter"
                        error={(errors as any)?.[TOTAL_DEBT]?.message}
                        isRequired={requiredFields.includes(
                          `${TOTAL_DEBT}`
                        )}
                        variant="float"
                        startIcon="₹"
                      />
                      <FormInput
                        name={`${RONW}`}
                        control={form.control}
                        label="RONW(in %)"
                        placeholder="Please enter"
                        error={(errors as any)?.[RONW]?.message}
                        isRequired={requiredFields.includes(`${RONW}`)}
                        variant="float"
                      />
                    </div>
                  </div>
                
              

              <div className="flex flex-row justify-end gap-3  py-3">
                <Button type="submit" disabled={isAddPending}>
                  {isAddPending ? <Loader variant="secondary" /> : <></>}
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default MbaplFinancialReporting;
